import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskCalendarChanges_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import useDirectoryInfo from 'src/hooks/useDirectoryInfo';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskCalendarChanges_ActivityLogFragment;
}

const ActivityLogTaskCalendarChanges: FCWithFragments<Fragments> = ({ activityLog }) => {
  const directoryInfo = useDirectoryInfo();
  const { calendarName } = directoryInfo;

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.syncedChangesFromCalendar"
      actionLabelValues={{ calendarName }}
    />
  );
};

ActivityLogTaskCalendarChanges.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskCalendarChanges_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskCalendarChanges;
